// Shareable state in the URL: ?t=1942.78&s=8&c=Q362&m=20.5,48.1,4.2, or a replay: ?r=ww2 (curated id or a QID)

export interface UrlState { t?: number; s?: number; c?: string; m?: { lon: number; lat: number; zoom: number }; r?: string }

export function parseUrl(search: string): UrlState {
  const q = new URLSearchParams(search);
  const out: UrlState = {};
  const num = (k: string) => {
    const v = q.get(k);
    if (v == null || v.trim() === "") return undefined;
    const x = Number(v);
    return Number.isFinite(x) ? x : undefined;
  };
  out.t = num("t");
  out.s = num("s");
  const c = q.get("c");
  if (c && /^[A-Za-z0-9.\-]{1,40}$/.test(c)) out.c = c;
  const r = q.get("r");
  if (r && /^[A-Za-z0-9\-]{1,40}$/.test(r)) out.r = r;
  const m = q.get("m")?.split(",").map(Number);
  if (m && m.length === 3 && m.every(Number.isFinite) && Math.abs(m[0]) <= 360 && Math.abs(m[1]) <= 90 && m[2] >= 0 && m[2] <= 22) {
    out.m = { lon: m[0], lat: m[1], zoom: m[2] };
  }
  return out;
}

export function formatUrl(s: UrlState): string {
  if (s.r) return `?r=${encodeURIComponent(s.r)}`; // a replay link starts the replay from the beginning
  const q = new URLSearchParams();
  if (s.t != null) q.set("t", s.t.toFixed(s.s != null && s.s < 2 ? 4 : 2));
  if (s.s != null) q.set("s", s.s < 1 ? s.s.toFixed(3) : s.s.toFixed(s.s < 20 ? 1 : 0));
  if (s.c) q.set("c", s.c);
  if (s.m) q.set("m", `${s.m.lon.toFixed(2)},${s.m.lat.toFixed(2)},${s.m.zoom.toFixed(1)}`);
  const str = q.toString();
  return str ? `?${str}` : "";
}
